module.exports = __webpack_public_path__ + "img/autogun.0f5a7ad3.svg";